import { ELECTRICITY_SYSTEM_TYPE } from "@app/models/commissioning-mapped-data.interface";

// This is only required for OTHER
export type SystemTypeId =
  | "systemTypePV"
  | "systemTypeSTORAGE"
  | "systemTypeCHARGING_DEVICE"
  | "systemTypeHEAT_PUMP"
  | "systemTypeOTHER";

export const SYSTEM_TYPE_ID_BY_SYSTEM_TYPE: Record<
  ELECTRICITY_SYSTEM_TYPE,
  SystemTypeId
> = {
  [ELECTRICITY_SYSTEM_TYPE.PV]: "systemTypePV",
  [ELECTRICITY_SYSTEM_TYPE.STORAGE]: "systemTypeSTORAGE",
  [ELECTRICITY_SYSTEM_TYPE.CHARGING_DEVICE]: "systemTypeCHARGING_DEVICE",
  [ELECTRICITY_SYSTEM_TYPE.HEAT_PUMP]: "systemTypeHEAT_PUMP",
  [ELECTRICITY_SYSTEM_TYPE.OTHER]: "systemTypeOTHER",
} as const;
